document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-newsletter-popup]');
  const closeButtons = document.querySelectorAll('[data-newsletter-close]');

  if (!popup) return;

  const form = popup.querySelector('#NewsletterPopupForm');
  const formContent = popup.querySelector('[data-newsletter-form-content]');
  const successContent = popup.querySelector('[data-newsletter-success]');

  const openPopup = () => {
    popup.classList.add('is-active');
    document.body.classList.add('waitlist-popup-open');

    requestAnimationFrame(() => {
      popup.classList.add('is-visible');
    });
  };

  const closePopup = () => {
    popup.classList.remove('is-visible');
    document.body.classList.remove('waitlist-popup-open');

    setTimeout(() => {
      popup.classList.remove('is-active');
    }, 350);
  };

  const showSuccess = () => {
    if (formContent) formContent.hidden = true;
    if (successContent) successContent.hidden = false;
  };

  if (form) {
    form.addEventListener('submit', () => {
      sessionStorage.setItem('newsletter_popup_submitted', 'true');
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '.newsletter-trigger, .c-newsletter-form, .c-newsletter-input, .c-newsletter-submit, a[href="#join-newsletter"], button[name="join-newsletter"]'
    );

    if (!trigger) return;

    event.preventDefault();
    openPopup();
  });

  document.addEventListener('focusin', (event) => {
    if (!event.target.matches('.c-newsletter-input')) return;

    event.preventDefault();
    event.target.blur();
    openPopup();
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-active')) {
      closePopup();
    }
  });

  const urlParams = new URLSearchParams(window.location.search);
  const wasNewsletterSubmitted =
    sessionStorage.getItem('newsletter_popup_submitted') === 'true';

  if (urlParams.get('customer_posted') === 'true' && wasNewsletterSubmitted) {
    openPopup();
    showSuccess();

    sessionStorage.removeItem('newsletter_popup_submitted');

    if (history.replaceState) {
      history.replaceState(null, '', window.location.pathname);
    }
  }
});